module.exports = __webpack_public_path__ + "ff6498a7fc38a73df0426ffcb33d1330.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/walibi-holland-webfont.eot
// module id = 11
// module chunks = 0